import { supabase } from '../supabase/supabase';

export async function getAutoConfirmationSettings() {
  const { data, error } = await supabase.rpc(
    'get_auto_confirmation_settings_1791001000000'
  );

  if (error) {
    throw error;
  }

  return data?.[0] || null;
}

export async function updateAutoConfirmationDays(days) {
  const { data, error } = await supabase.rpc(
    'admin_set_auto_confirmation_days_1791001000000',
    { p_days: days }
  );

  if (error) {
    throw error;
  }

  return data;
}

export async function confirmDueOrder(orderId) {
  const { data, error } = await supabase.rpc(
    'confirm_due_order_1793016000000',
    { p_order_id: orderId }
  );

  if (error) {
    throw error;
  }

  return data;
}

export async function getFulfillmentSettings() {
  const { data, error } = await supabase.rpc(
    'get_fulfillment_settings_1793005000000'
  );

  if (error) {
    throw error;
  }

  return data?.[0] || null;
}

export async function updateFulfillmentSettings(settings) {
  const { data, error } = await supabase.rpc(
    'admin_update_fulfillment_settings_1793005000000',
    {
      p_acceptance_window_minutes: settings.acceptanceWindowMinutes,
      p_grace_period_hours: settings.gracePeriodHours,
      p_restriction_threshold: settings.restrictionThreshold
    }
  );

  if (error) {
    throw error;
  }

  return data;
}

export async function approveFulfillmentDate(orderId, scheduledAt) {
  const { data, error } = await supabase.rpc(
    'buyer_approve_fulfillment_date_1793005000000',
    {
      p_order_id: orderId,
      p_scheduled_at: scheduledAt
    }
  );

  if (error) {
    throw error;
  }

  return data;
}

export async function rejectFulfillmentDate(orderId) {
  const { data, error } = await supabase.rpc(
    'buyer_reject_fulfillment_date_1793005000000',
    { p_order_id: orderId }
  );

  if (error) {
    throw error;
  }

  return data;
}
